import type { PricingPlanCategory } from '../../content';
import type { BillingInterval } from '../types';

export const BASE_MONTHLY_PRICES: Record<PricingPlanCategory, number> = {
  food: 30,
  wellness: 50,
};

export const BILLING_INTERVAL_MONTHS: Record<BillingInterval, number> = {
  monthly: 1,
  quarterly: 3,
  semiannual: 6,
};

/** Percent discount off the undiscounted total for the period. */
export const BILLING_INTERVAL_DISCOUNT: Record<BillingInterval, number> = {
  monthly: 0,
  quarterly: 10,
  semiannual: 15,
};

export type BillingQuote = {
  interval: BillingInterval;
  months: number;
  baseMonthlyPrice: number;
  effectiveMonthlyPrice: number;
  totalPrice: number;
  savings: number;
};

export function formatEuro(amount: number): string {
  const hasDecimals = Math.round(amount * 100) % 100 !== 0;
  return amount.toLocaleString('es-ES', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  });
}

export function getBillingQuote(
  category: PricingPlanCategory,
  interval: BillingInterval,
): BillingQuote {
  const baseMonthlyPrice = BASE_MONTHLY_PRICES[category];
  const months = BILLING_INTERVAL_MONTHS[interval];
  const discount = BILLING_INTERVAL_DISCOUNT[interval];
  const undiscountedTotal = baseMonthlyPrice * months;
  const totalPrice = undiscountedTotal * (1 - discount / 100);
  const effectiveMonthlyPrice = totalPrice / months;
  const savings = undiscountedTotal - totalPrice;

  return {
    interval,
    months,
    baseMonthlyPrice,
    effectiveMonthlyPrice,
    totalPrice,
    savings,
  };
}

export function getListingValidUntilFromActivation(
  activatedAt: Date,
  interval: BillingInterval,
): Date {
  return addMonths(activatedAt, BILLING_INTERVAL_MONTHS[interval]);
}

export function addMonths(date: Date, months: number): Date {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}
